import okiApplication from '../../../api/oki-api';
import { OKI_TECHNICAL_FAILURE } from '../oki-vuex';

const OKI_GET_SCHOOLS = 'OKI_GET_SCHOOLS';
const OKI_RESET_SCHOOLS = 'OKI_RESET_SCHOOLS';
const OKI_SAVE_FINANCIAL_DATA = 'OKI_SAVE_FINANCIAL_DATA';

const okiFinancialState = {
	schools: [],
	financialData: {}
};
const okiFinancialActions = {
	getSchools({ commit }, value) {
		okiApplication.lookupSchools(value).then(
			(response) => {
				commit(OKI_GET_SCHOOLS, response.data);
			},
			() => {
				commit(OKI_TECHNICAL_FAILURE);
			}
		);
	},
	resetSchools({ commit }) {
		commit(OKI_RESET_SCHOOLS);
	},
	postFinancialForm({ commit, rootState, dispatch }, data) {
		data.claim = data.claim || {};
		data.claim.sessionId = rootState.sessionId;
		commit(OKI_SAVE_FINANCIAL_DATA, data.claim.financialData);
		return okiApplication.postForm(data).then(
			(response) => {
				return Promise.resolve(response);
			},
			(error) => {
				if (error.response.data.financialData) {
					dispatch('collectErrorCodes', error.response.data.financialData, { root: true });
				}
				commit(OKI_TECHNICAL_FAILURE);
				return Promise.reject(error);
			}
		);
	},
	postTaFinancial(context, data) {
		okiApplication.postTaData(data);
	}
};

const okiFinancialMutations = {
	[OKI_GET_SCHOOLS](state, schools) {
		state.schools = schools;
	},
	[OKI_RESET_SCHOOLS](state) {
		state.schools = [];
	},
	[OKI_SAVE_FINANCIAL_DATA](state, data) {
		state.financialData = data;
	}
};

export default {
	state: okiFinancialState,
	mutations: okiFinancialMutations,
	actions: okiFinancialActions
};
